<template>
  <div class="animated fadeIn">
    <b-card v-if="show">
      <template slot="header" >
        <i class='fa fa-align-justify' v-if="server && server.url"></i>
        <b-form-select v-model="server.id" v-on:change="changetarget($event, server)" size="sm" style="max-width: 20rem;">
          <option v-for="item in targetlist" :key="item.id" :value="item.id">{{item.url}}</option>
        </b-form-select>
        <strong class="pull-right">Nickname : {{server.nickname}} / Version : {{server.version}} / IP_Addr : {{server.ip_addr}}</strong>
      </template>
      <b-card>
        <b-row>
          <b-col md="5">
            <strong>Policy Security Level</strong>
            <small>( Level : {{policy.level}} )</small>
            <b-form-radio-group id="ph_level" v-model="policy.level" :options="[1,2,3,4]">
            </b-form-radio-group>
          </b-col>
          <b-col md="5">
            <strong>Firewall Mode :
              <b-badge v-if="policy.mode == 'Off'" variant="secondary">Off</b-badge>
              <b-badge v-if="policy.mode == 'DetectionOnly'" variant="warning">DetectionOnly</b-badge>
              <b-badge v-if="policy.mode == 'On'" variant="danger">Block</b-badge>
            </strong>
              <b-form-radio-group id="ph_mode" v-model="policy.mode" :options="mode_set">
            </b-form-radio-group>
          </b-col>
          <!-- 매니저는 설정 변경 불가 -->
          <!-- <b-col md="2">
            <div class="pull-right">
              <b-button size="sm" variant="success" @click="save_mode">Apply</b-button>
            </div>
          </b-col> -->
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <b-form-group>
              <h5>
                <b-badge variant="warning">Notice</b-badge>
                <small> <strong> The policy security level defaults to 1 and higher levels may affect the service </strong></small><br>
                <small> <strong> * Off : Disable Web Castle Activation </strong></small><br>
                <small> <strong> * DetectionOnly : Detect Only while on Activation </strong></small><br>
                <small> <strong> * On : Block While On Activation </strong></small>
              </h5>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <b-tabs v-model="tabIndex">
        <b-tab title="Policy (CRS)" @click="get()">
          <template v-if="!rule_data">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Policy Name</th>
                  <th scope="col">Activation</th>
                  <th scope="col">Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in rule_set" :key="v.index">
                  <th scope="row">{{v.name}}</th>
                  <td><b-form-checkbox v-if="v.user" v-model="rule[k]">{{rule[k] ? 'On' : 'Off'}}</b-form-checkbox></td>
                  <td><b-btn size="sm" @click="edit_rule(k)">More</b-btn></td>
                </tr>
              </tbody>
            </table>
            <hr>
            <!-- 매니저는 사용자 설정 변경 불가 -->
            <!-- <b-row>
              <b-col class="md-4">
                <div class="pull-right">
                  <b-btn size="sm" @click="allSelect">All(On / Off)</b-btn>
                  <b-button size="sm" variant="success" @click="confirm = true"> Apply </b-button>
                </div>
              </b-col>
            </b-row> -->
          </template>
          <template v-else>
            <b-row>
              <b-col>
                <strong>  {{rule_select}} </strong><br/><br/>
                <small>Paste to fit the form is recommended</small>
              </b-col>
              <b-col class="md-4">
                <div class="pull-right">
                  <!-- 매니저는 사용자 설정 변경 불가 -->
                  <!-- <b-button size="sm" variant="success" @click="confirm = true"> Apply </b-button> -->
                  <b-button size="sm" variant="success" @click="rule_data = ''"> Cancel </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-form-textarea id="ph_content" v-model="rule_data" :max-rows="50"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </b-tab>
        <b-tab title="USER Policy (CRS)" @click="get_rule('user');">
          <b-row>
            <b-col>
              <strong>User Rule Setting</strong><br/><br/>
              <small>Paste to fit the form is recommended</small>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="confirm = true"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.rule" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="IP Exception" @click="location=2; get();">
          <b-row>
            <b-col>
              <strong>Add Exception IP</strong><br/><br/>
              <small>Type one IP in a row.</small>
              <br><br>
              <span>* Example</span><br><br>
              <span>10.0.0.1</span><br>
              <span>10.0.0.2</span>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="save_addr"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.exclude_addr" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Domain List" @click="get()">
          <b-row>
            <b-col>
              <strong>Use Domain</strong><br/><br/>
              <small>In one row, enter one domain.</small>
              <br><br>
              <span>* Example</span><br><br>
              <span>test.co.kr</span><br>
              <span>test.com</span>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="save_domain"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.domain_list" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Domain Exception" @click="get()">
          <b-row>
            <b-col>
              <strong>Exception handling domain</strong><br/><br/>
              <small>In one row, enter one domain.</small>
              <br><br>
              <span>* Example</span><br><br>
              <span>test.co.kr</span><br>

              <span>test.com</span>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="save_skip"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.skip_domain_list" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Path Block" @click="get()">
          <b-row>
            <b-col>
              <strong>show Path Block</strong><br/><br/>
              <small>In one row, enter one Path.</small>
              <br><br>
              <span>* Example</span><br><br>
              <span>/admin</span><br>
              <span>/images</span>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="save_path"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.block_url" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Parameter Block" @click="get()">
          <b-row>
            <b-col>
              <strong>Parameter(Query String)</strong><br/><br/>
              <small>In one row, enter one Parameter.</small>
              <br><br>
              <span>* Example</span><br><br>
              <span>id=test : Detects if query string has id=test</span><br>
              <span>test : Detects if query string has test</span>
            </b-col>
            <b-col class="md-4">
              <div class="pull-right">
                <b-button size="sm" variant="outline-info" @click="explan"><i class="fa fa-question"></i></b-button>
                <!-- 매니저는 사용자 설정 변경 불가 -->
                <!-- <b-button size="sm" variant="success" @click="save_param"> Apply </b-button> -->
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.block_parameter" :max-rows="50"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Log" @click="refresh()">
          <b-row>
            <b-col>
              <strong>Displays the detection/blocking logs for the server.</strong><br/><br/>
              <span>* Only the last 50 real-time displays</span><br>
              <span v-if="th" class="float-right">
                <i class="fa fa-refresh fa-spin"></i>
                Real-time updating
              </span>
              <br><br>
              <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
                :items="getItems" :fields="fields" :current-page="currentPage" :per-page="50">
                <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
                <template slot="created_at" slot-scope="row">{{row.item.created_at|datetime}}</template>
                <template slot="target" slot-scope="row">{{row.item.target}}{{row}}</template>
                <template slot="protocol" slot-scope="row">{{row.item.protocol}}({{row.item.method}})</template>
                <template slot="is_block" slot-scope="row">
                  <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
                  <b-badge v-else variant="warning">DetectionOnly</b-badge>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal :title="m.title"  class="modal-danger" v-model="confirm" @ok="save" ok-variant="danger">
      {{m.content}}
    </b-modal>
    <b-modal title="USER Policy (CRS)"  header-bg-variant="info" v-model="explan_user_crs" no-close-on-backdrop ok-only>
      <p>ModSecurity Paste it according to the form.</p>
      <p>ex ) #SecRule ARGS test "id:132,phase:1,deny"
        SecRule ARGS test "id:133,phase:1,deny"
        SecRule REQUEST_HEADERS:Content-Type "(?:application(?:/soap\+|/)|text/)xml" \
        "id:'222',phase:1,t:none,t:lowercase,deny,log,ctl:requestBodyProcessor=XML"</p>
      <p>If you type like this, block the word test.</p>
    </b-modal>
    <b-modal title="IP Exception"  header-bg-variant="info" v-model="explan_ip" ok-variant="success">
      <p>Enter the IP you want to register as an exception to the web fire barrier.</p>
      <p>ex ) 211.222.235.14</p>
      <p>Once entered, the IP you entered will not be affected by any firewall.</p>
    </b-modal>
    <b-modal title="Domain List"  header-bg-variant="info" v-model="explan_domain_list" no-close-on-backdrop ok-only>
      <p>You can make a note of the list of domains currently being managed by the Web server.</p>
      <p>ex )</p>
      <p>test.co.kr</p>
      <p>test.com</p>
      <p>The Domain List feature has nothing to do with the Web Firewall.</p>
    </b-modal>
    <b-modal title="Domain Exception"  header-bg-variant="info" v-model="explan_domain" ok-only no-close-on-backdrop ok-variant="success">
      <p>Enter the domain you want to register as an exception to the web firewall.</p>
      <p>ex ) console.f1secaas.net </p>
      <p>The domain you entered is not affected by the firewall.</p>
    </b-modal>
    <b-modal title="Path Block"  header-bg-variant="info" v-model="explan_path_block" ok-variant="success">
      <p>Block pages from specific paths.</p>
      <p>ex ) https://console.us.uwss.online/main/index.html</p>
      <p>Blocking the path /main that looks like above will block index.html pages.</p>
    </b-modal>
    <b-modal title="Parameter Block"  header-bg-variant="info" v-model="explan_params_block" ok-only no-close-on-backdrop ok-variant="success">
      <p>Block certain parameters.</p>
      <p>`ex ) kyword=password</p>
      <p>Blocking the password parameter that looks like above will detect/block the parameter of the word password.</p>
    </b-modal>
  </div>
</template>

<script>

import { Api, ModuleApi, auth } from '@/service';
import punycode from 'punycode';
import * as forge from 'node-forge'

const mode_set = ['Off', 'DetectionOnly', 'On'];
const rule_set = {
  'default' : { user: false, name: 'DEFAULT.conf'},
  'Setup' : { user: false, name: 'CRS-SETUP.conf' },
  'Rule900' : { user: false, name: 'REQUEST-900-EXCLUSION-RULES-BEFORE-CRS.conf' },
  'Rule901' : { user: false, name: 'REQUEST-901-INITIALIZATION.conf' },
  'Rule903_9001' : { user: true, name: 'REQUEST-903.9001-DRUPAL-EXCLUSION-RULES.conf' },
  'Rule903_9002' : { user: true, name: 'REQUEST-903.9002-WORDPRESS-EXCLUSION-RULES.conf' },
  'Rule903_9003' : { user: true, name: 'REQUEST-903.9003-NEXTCLOUD-EXCLUSION-RULES.conf' },
  'Rule903_9004' : { user: true, name: 'REQUEST-903.9004-DOKUWIKI-EXCLUSION-RULES.conf' },
  'Rule903_9005' : { user: true, name: 'REQUEST-903.9005-CPANEL-EXCLUSION-RULES.conf' },
  'Rule905' : { user: true, name: 'REQUEST-905-COMMON-EXCEPTIONS.conf' },
  'Rule910' : { user: true, name: 'REQUEST-910-IP-REPUTATION.conf' },
  'Rule911' : { user: true, name: 'REQUEST-911-METHOD-ENFORCEMENT.conf' },
  'Rule912' : { user: true, name: 'REQUEST-912-DOS-PROTECTION.conf' },
  'Rule913' : { user: true, name: 'REQUEST-913-SCANNER-DETECTION.conf' },
  'Rule914' : { user: true, name: 'REQUEST-914-FILE-DETECTION.conf' },
  'Rule920' : { user: true, name: 'REQUEST-920-PROTOCOL-ENFORCEMENT.conf' },
  'Rule921' : { user: true, name: 'REQUEST-921-PROTOCOL-ATTACK.conf' },
  'Rule930' : { user: true, name: 'REQUEST-930-APPLICATION-ATTACK-LFI.conf' },
  'Rule931' : { user: true, name: 'REQUEST-931-APPLICATION-ATTACK-RFI.conf' },
  'Rule932' : { user: true, name: 'REQUEST-932-APPLICATION-ATTACK-RCE.conf' },
  'Rule933' : { user: true, name: 'REQUEST-933-APPLICATION-ATTACK-PHP.conf' },
  'Rule941' : { user: true, name: 'REQUEST-941-APPLICATION-ATTACK-XSS.conf' },
  'Rule942' : { user: true, name: 'REQUEST-942-APPLICATION-ATTACK-SQLI.conf' },
  'Rule943' : { user: true, name: 'REQUEST-943-APPLICATION-ATTACK-SESSION-FIXATION.conf' },
  'Rule944' : { user: true, name: 'REQUEST-944-APPLICATION-ATTACK-JAVA.conf' },
  'Rule949' : { user: true, name: 'REQUEST-949-BLOCKING-EVALUATION.conf' },
  'Rule950' : { user: true, name: 'RESPONSE-950-DATA-LEAKAGES.conf' },
  'Rule951' : { user: true, name: 'RESPONSE-951-DATA-LEAKAGES-SQL.conf' },
  'Rule952' : { user: true, name: 'RESPONSE-952-DATA-LEAKAGES-JAVA.conf' },
  'Rule953' : { user: true, name: 'RESPONSE-953-DATA-LEAKAGES-PHP.conf' },
  'Rule954' : { user: true, name: 'RESPONSE-954-DATA-LEAKAGES-IIS.conf' },
  'Rule959' : { user: true, name: 'RESPONSE-959-BLOCKING-EVALUATION.conf' },
  'Rule980' : { user: true, name: 'RESPONSE-980-CORRELATION.conf' },
  'Rule999' : { user: false, name: 'RESPONSE-999-EXCLUSION-RULES-AFTER-CRS.conf' }
};
const default_policy = () => ({
  mode: 1,
  level: 1
});
const default_rule = () => ({
  Rule900 : false,
  Rule901 : false,
  Rule903_9001 : false,
  Rule903_9002 : false,
  Rule903_9003 : false,
  Rule903_9004 : false,
  Rule903_9005 : false,
  Rule905 : false,
  Rule910 : false,
  Rule911 : false,
  Rule912 : false,
  Rule913 : false,
  Rule914 : false,
  Rule920 : false,
  Rule921 : false,
  Rule930 : false,
  Rule931 : false,
  Rule932 : false,
  Rule933 : false,
  Rule941 : false,
  Rule942 : false,
  Rule943 : false,
  Rule944 : false,
  Rule949 : false,
  Rule950 : false,
  Rule951 : false,
  Rule952 : false,
  Rule953 : false,
  Rule954 : false,
  Rule959 : false,
  Rule980 : false,
  Rule999 : false
});
const default_user = () => ({
  exclude_addr: '',
  domain_list: '',
  skip_domain_list: '',
  block_parameter: '',
  block_url: '',
  rule: ''
});


export default {
  data: () => {
    return {
      explan_confirm : false,
      explan_user_crs : false,
      explan_ip : false,
      explan_domain_list : false,
      explan_domain : false,
      explan_params_block : false,
      explan_path_block : false,
      confirm : false,
      mode_set: mode_set,
      rule_set: rule_set,
      perPage: 50,
      currentPage: 1,
      totalRows: 50,
      tabIndex: 0,
      server : { url : "" },
      policy: {},
      rule: {},
      rule_select : '',
      rule_key : '',
      rule_data : '',
      user: {}, // 사용자 설정
      targetlist: [],
      serverurl : '',
      show: true,
      fields : [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 10%' },
        { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 5%' },
        { key: 'protocol', label: 'Protocol', sortable: false, thStyle: 'width: 10%' },
        { key: 'method', label: 'Method', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
        { key: 'uri', label: 'URI', sortable: false, thStyle: 'width: 10%' },
      ],
      sel_status : false,
      th : undefined,
      auth : auth,
      m : { title : 'Attention to responsibilities', content : 'Modifying Policy CRS may affect the service Familiarize yourself with how to use it and recommend using it' }
    }
  },
  computed: {
    startRow () { return this.totalRows - (this.currentPage - 1) * this.perPage; }
  },
  methods: {
    allSelect() { this.sel_status = !this.sel_status; _.forEach(_.keys(this.rule), k => { this.rule[k] = this.sel_status; }) },
    getItems(ctx) { return this.load(ctx); },
    async load() {

      let so = {
        target : 'webcastle.log',
        cmd : 'list',
        offset : 0,
        limit :  50,
        body : {
          and : [ { "name" : "agent_id", "value" : Number(this.number), "op" : "=" } ],
          sort : [ { "name" : "group_id" }, { "name" : "id", "op" : "desc" } ]
        }
      }
      return await Api.Manager(so).then(rs => { this.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    sync_log() {
      clearTimeout(this.th);
      if(this.tabIndex == 7) { this.$refs._list.refresh(); console.log('refresh real time') }
      this.th = setTimeout(() => { this.sync_log(); }, 5000 );
    },
    refresh() { if(!this.th) { this.sync_log(), console.log("start sync_log") } this.$refs._list.refresh(); },
    async changetarget(s) { //Target List Change
      // this.$router.replace({ name: 'modules', params: { version : (s.version ?) id: s.id }});
      console.info(s, "ChangeTarget")
      let rs = await Api.Manager_Call('webcastle.agent',  'detail', { id : s })
      console.info(rs.body.version.startsWith('v1'), rs.id)
      if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
      this.$router.push({ name: 'webcastle_modules', params: { version : rs.body.version.startsWith('v1') ? 'v1' : 'v2', id: rs.body.id }})
    },
    async list() { //Target List
      try {
        Api.Manager_Call("webcastle.agent", "list", { and: [{ "name": "is_del", "value" : false, "op" : "=" }]}).then(rs => { console.info(rs); this.targetlist = rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      } catch(e) {
        this.$toastr.e('miss Connection Error Code : ');
      }
    },
    // initialize

    async get(id = this.$route.params.id){
      // console.info(id)
      // API 에서 module 정보 획득.
      try {
        this.number = id;
        Api.Manager_Call('webcastle.agent', 'detail', { id : id })
          .then(rs => { console.info(rs.body);  this.server = rs.body; !this.server ? console.error(rs.reson) : console.log("[ok] server load ") })
          .then(() => ModuleApi.setServer(this.server))
          .then(async () => {
            // console.info(rs, "RRRSSS")
            this.policy = default_policy();
            this.rule = default_rule();
            this.user = default_user();
            console.info(this.server, "SERVER")
            if(this.tabIndex == 1) { await this.get_rule('user'); }

            let setup = await ModuleApi.setup.get();
            console.info(setup, "SP")
            // console.log("A")
            this.policy.mode = setup.Mode; //_.indexOf(mode_set, setup.Mode);
            this.policy.level = setup.Level;
            // console.log("B")
            this.user.exclude_addr = (setup.CleanAddress || '').split(',').join('\n');
            this.user.domain_list = _.map((setup.DomainList || '').split(','), x => punycode.toUnicode(x)).join('\n');
            this.user.skip_domain_list = _.map((setup.SkipDomainList || '').split(','), x => punycode.toUnicode(x)).join('\n');
            this.user.block_parameter = forge.util.decodeUtf8(forge.util.decode64(setup.BlockParamter || ''));
            this.user.block_url = forge.util.decodeUtf8(forge.util.decode64(setup.BlockUrl || ''));
            // console.log("C")
            _.forEach(_.filter(_.map(setup, (v, k) => _.startsWith(k, 'Rule') && v == 'On' && k)), k => this.rule[k] = true);
          })
          // .catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      } catch(e) {
        this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 1');
      }
    },
    async edit_rule(k) {
      this.rule_key = k;
      await this.get_rule(k);
    },
    async get_rule(rule) {
      try {
        // if(this.tabIndex == 0) { this.rule_select = this.rule_set[rule]['name']; }
        // if(this.tabIndex == 0 &&  rule != 'user')
        if(rule == 'user') { this.user.rule = await ModuleApi.user.get(); }
        if(rule == 'Setup') { this.rule_data = await ModuleApi.rule.get('setup'); }
        if(rule == 'default') { this.rule_data = await ModuleApi.rule.get('default')}
        if(_.startsWith(rule, 'Rule')) { this.rule_data = await ModuleApi.rule.get(rule.substr(4)); }
      } catch(e) {
        this.$toastr.e(e.data ? e.data : e.statusText, 'miss Connection Error Code : 2');

      }
      return '';
    },
    async put_rule(rule) {
      try {
        if(rule == 'user') { await ModuleApi.user.put(this.user.rule); }
        if(rule == 'Setup') { await ModuleApi.rule.put('setup', this.rule_data); }
        if(rule == 'default') { await ModuleApi.rule.put('default' , this.rule_data); }
        if(_.startsWith(rule, 'Rule')) { await ModuleApi.rule.put(rule.substr(4), this.rule_data); }
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) {
        this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 3');
      }
    },
    async save_mode() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.Mode = this.policy.mode;
        setup.Level = this.policy.level;
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Agent setting request');
        await ModuleApi.restart();
        // let updateInfo = _.assign({}, this.server, { level : this.policy.level, mode : this.mode_set.indexOf(this.policy.mode)})  ;
        // Api.Manager_Call('webcastle.agent', "update", updateInfo).then(() => this.$toastr.s('Agent setting saved'))
        //   .catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 4 - db'))
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 4'); }
    },
    async save_policy() {
      try {
        let setup = await ModuleApi.setup.get();
        _.forEach(this.rule, (v, k) => { setup[k] = v ? 'On' : 'Off' });
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 5'); }
    },

    async save_addr() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.CleanAddress = _.compact((this.user.exclude_addr || '').split('\n')).join(',');
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 6'); }
    },
    async save_domain() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.DomainList = _.map(_.compact((this.user.domain_list || '').split('\n')), x => punycode.toASCII(x)).join(',');
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 7'); }
    },
    async save_skip() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.SkipDomainList = _.map(_.compact((this.user.skip_domain_list || '').split('\n')), x => punycode.toASCII(x)).join(',');
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 8'); }
    },
    async save_path() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.BlockUrl = forge.util.encode64(forge.util.encodeUtf8(this.user.block_url || ''));
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 9'); }
    },
    async save_param() {
      try {
        let setup = await ModuleApi.setup.get();
        setup.BlockParamter = forge.util.encode64(forge.util.encodeUtf8(this.user.block_parameter || ''));
        await ModuleApi.setup.put(setup);
        this.$toastr.i('Saved');
        await ModuleApi.restart();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 10'); }
    },
    async save() {
      if(this.tabIndex == 0) { this.rule_data == '' ? this.save_policy() : this.put_rule(this.rule_key) }
      if(this.tabIndex == 1) { this.put_rule('user') }
      console.log("save location : ", this.tabIndex)
    },
    async explan() {
      // this.explan_confirm = true;
      console.log("save location : ", this.tabIndex)
      // if(this.tabIndex == 1) { this.m = { title : 'USER 정책(CRS)', content : '#SecRule ARGS test "id:132,phase:1,deny"<br>CRS URL' } }
      if(this.tabIndex == 1) { this.explan_user_crs = true; }
      if(this.tabIndex == 2) { this.explan_ip = true; }
      if(this.tabIndex == 3) { this.explan_domain_list = true; }
      if(this.tabIndex == 4) { this.explan_domain = true; }
      if(this.tabIndex == 5) { this.explan_path_block = true; }
      if(this.tabIndex == 6) { this.explan_params_block = true; }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created() {
    console.log('modules.detail.vue', 'created');
    return this.list();
  },
  destroyed() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    console.log('modules.detail.vue', 'destroyed'); },
  mounted() {
    console.log('modules.detail.vue', 'mounted');
    this.get(this.$route.params.id);
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
  },
}
</script>
